import { Gender } from "../common/Gender";

export interface Member {
  id: number | null;
  firstName: string;
  lastName: string;
  gender: Gender;
  birthDate: string;
  address: string;
  email: string;
  phone: string;
  nationalId: string;
  note: string;
}

export const memberInit: Member = {
  id: null,
  firstName: "",
  lastName: "",
  gender: Gender.NONE,
  birthDate: "",
  address: "",
  email: "",
  phone: "",
  nationalId: "",
  note: "",
};
